<template>
    <div class="goals-icon">
        <svg class="goal-icon-svg" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path v-for="svgPath in svgPathArray" :key="svgPath"
            :d="svgPath"
            fill="#A2A2A2"
            ></path>
        </svg>
        <div v-if="!isSlider" class="goals-icon-image-container">
            <div :class="this.lineClass"></div>
            <div class="goals-icon-image-circle-small"></div>
            <div class="goals-icon-image-circle"></div>
        </div>
        <div class="goals-icon-text about-text" :class="{'mt-2': isSlider}">
            {{ text }}
        </div>
    </div>
</template>
<script>

export default {
    name: 'GoalsIcon',
    props: {
        svgPathArray: Array,
        text: String,
        isLeft: Boolean,
        isRight: Boolean,
        isSlider: Boolean
    },
    computed:{
        lineClass(){
            if (!this.isLeft && !this.isRight)
                return "goals-icon-image-line"
            if (this.isLeft && !this.isRight)
                return "goals-icon-image-line-left"
            if (!this.isLeft && this.isRight)
                return "goals-icon-image-line-right"
            if (this.isLeft && this.isRight)
                return "goals-icon-image-line-left-right"
            return "goals-icon-image-line"
        }
    }
}
</script>
